export default __webpack_public_path__ + "locales/uk-UA/ChangeUserTypeDialog.json?hash=b4bfc0842fc0fbc59956dc729f792527";